// extracted by mini-css-extract-plugin
module.exports = {"proportionChangeContainer":"rZtflDhp","outsideHoursTag":"In8UFPCz","pre":"EPJddHO1","after":"N2g6n_MS","liveLabel":"ZbvNuhY3","liveLabelContainer":"rjeI1iIM","dateSpan":"ecxtD3NC"};